import React, {
  FunctionComponent, useEffect, useRef, useState 
} from 'react';
import { RootRef, TableCellProps } from '@material-ui/core';
import {
  Cell
} from '@liveramp/motif/core/Table';
import Tooltip from '@liveramp/motif/core/Tooltip';
import styles from './styles.module.scss';

const TableCell: FunctionComponent<TableCellProps> = (props) => {
  const ref = useRef<HTMLTableCellElement>();
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const [isMouseOver, setIsMouseOver] = useState(false);
  useEffect(() => {
    if (ref && ref.current) {
      setIsTooltipVisible(ref.current.scrollWidth > ref.current.clientWidth);
    }
  },
  [isMouseOver]);
  return (
    <Cell
      {...props}
      onFocus={() => setIsMouseOver(true)}
      onMouseOver={() => setIsMouseOver(true)}
      onMouseLeave={() => setIsMouseOver(false)}
    >
      <RootRef rootRef={ref}>
        <Tooltip
          open={isTooltipVisible && isMouseOver}
          title={props.children}
          className={styles.cell}
          interactive
        >
          {props.children}
        </Tooltip>
      </RootRef>
    </Cell>
  );
};

export default TableCell;
